/** Price-list entry only. Never apply this to calculated order or quote amounts. */
export function ceilProcessingRate(value: number | string | null | undefined): number | null {
  if (value == null || value === "") return null;
  const number = Number(value);
  if (!Number.isFinite(number)) return null;
  return number < 0 ? number : Math.ceil(number);
}
